import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import 'rxjs/add/operator/toPromise';

@Injectable()
export class HmlSubmissionService {

  constructor(@Inject(HttpClient) private readonly _http: HttpClient) {
  }

  submitHmlFile(fileId: string) {
    let url = `/upload/file/submit/${fileId}/hml`;

    //ToDo This seems to be an AngularJS call, not using the new Angular HTTP lib or preferred structure
    return this._http.post(url, {})
      .pipe(map((resp: string)  => resp));
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
